import { faMinus, faPen, faSave } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useMap } from "@vis.gl/react-google-maps";
import { memo, useEffect, useState } from "react";
import { EditArea } from "../EditArea";
import { deleteArea } from "../../services/api";

export const Polygon = ({
  area,
  setSelected,
  selected,
  refetchArea,
  teamOwner,
}: {
  area: any;
  setSelected: (val: any) => void;
  selected: string;
  refetchArea: any;
  teamOwner: any;
}) => {
  const [polygonCoords, setPolygonCoords] = useState(
    JSON.parse(area.area_cordinates)
  );
  const [instance, setInstance] = useState<google.maps.Polygon | null>(null);
  const [clicked, setClicked] = useState(false);
  const [editable, setEditable] = useState(false);
  const [clickListener, setClickListener] =
    useState<google.maps.MapsEventListener | null>(null);

  const [showEdit, setShowEdit] = useState(false);

  const map = useMap();

  map?.addListener("click", () => {
    if (selected) {
      setSelected("");
    }
  });

  useEffect(() => {
    if (instance !== null) {
      instance.setMap(map);
      console.log("Polygon instance set on map");
    }
  }, [map]);

  useEffect(() => {
    if (instance !== null) {
      instance.setEditable(editable);
    }
    console.log("Polygon instance editable set to:", editable);
  }, [instance, editable]);

  useEffect(() => {
    if (instance !== null) {
      instance.setOptions({
        strokeWeight: clicked ? 4 : 2,
      });
    }
  }, [instance, clicked]);

  useEffect(() => {
    if (selected !== area.area_public_id) {
      setClicked(false);
      setEditable(false);
    }
  }, [selected, area.area_public_id]);

  useEffect(() => {
    if (typeof polygonCoords !== "undefined" && instance !== null) {
      instance.setPath(polygonCoords);
      console.log("Polygon path set to:", polygonCoords);
    }
  }, [instance, polygonCoords]);

  useEffect(() => {
    if (instance && editable) {
      const insertListener = google.maps.event.addListener(
        instance.getPath(),
        "insert_at",
        handleEdit
      );

      const setListener = google.maps.event.addListener(
        instance.getPath(),
        "set_at",
        handleEdit
      );

      console.log("Event listeners added for insert_at and set_at");

      return () => {
        google.maps.event.removeListener(insertListener);
        google.maps.event.removeListener(setListener);
        console.log("Event listeners removed for insert_at and set_at");
      };
    }
  }, [instance, polygonCoords, editable]);

  useEffect(() => {
    const polygon = new google.maps.Polygon({
      strokeColor: "#1D4ED8",
      strokeOpacity: 0.8,
      fillOpacity: 0.1,
      map,
    });

    if (polygonCoords) {
      polygon.setPath(polygonCoords);
    }

    setClickListener(
      google.maps.event.addListener(polygon, "click", function () {
        if (!selected) {
          setClicked(true);
          setSelected(area.area_public_id);
        }
      })
    );

    setInstance(polygon);

    return () => {
      if (clickListener) {
        google.maps.event.removeListener(clickListener);
      }
      polygon.setMap(null);
      console.log("Polygon instance removed from map");
    };
  }, []);

  const handleEdit = () => {
    if (!instance) {
      console.log("no instance");
      return;
    }
    console.log("handle edit called");
    const path = instance.getPath();
    const newCoords = path.getArray().map((latLng: any) => {
      return { lat: latLng.lat(), lng: latLng.lng() };
    });
    setPolygonCoords(newCoords);
    console.log("Updated coordinates:", newCoords);
  };

  const onDeleteArea = async () => {
    try {
      await deleteArea({
        public_id: area.area_public_id,
        user_id: area.user_public_id,
        area_id: area.area_id,
        area_name: area.area_name,
        area_cordinates: area.area_cordinates,
      });
      refetchArea();
      setSelected("");
    } catch (error) {
      console.error(error);
    }
  };

  return (
    <>
      {clicked && teamOwner && (
        <div className="absolute bottom-12 w-full flex gap-x-3 justify-center">
          <div>
            <button
              onClick={onDeleteArea}
              className="btn btn-primary px-3 py-1 btn-rounded icon shadow add-listing  z-20 relative"
            >
              <FontAwesomeIcon icon={faMinus} />
              <span> Delete Area</span>
            </button>
          </div>

          <div>
            <button
              onClick={() => setEditable(true)}
              className="btn btn-primary px-3 py-1 btn-rounded icon shadow add-listing  z-20 relative"
            >
              <FontAwesomeIcon icon={faPen} />
              <span> Edit</span>
            </button>
          </div>

          <div>
            <button
              onClick={() => setShowEdit(true)}
              className="btn btn-primary px-3 py-1 btn-rounded icon shadow add-listing  z-20 relative"
            >
              <FontAwesomeIcon icon={faSave} />
              <span> Save</span>
            </button>
          </div>
        </div>
      )}
      {showEdit ? (
        <EditArea
          area={{
            ...area,
            area_cordinates: polygonCoords,
          }}
          closeDrawing={console.log}
          onclose={() => setShowEdit(false)}
          refetch={console.log}
        />
      ) : null}
    </>
  );
};

export const PolygonF = memo(Polygon);
